export default __webpack_public_path__ + "static/coach-app-7e9c13b4a0d38e5afc98031ae1c47f80.jpg";